import { useMutation } from '@tanstack/react-query';

import { Promotion, PromotionCodeCheckParams } from '../types/commons';
import { post } from '../api/requester';

const promotions = {
  check: async (code: PromotionCodeCheckParams) => post('/promotions/check', { body: code }),
};

export const useCheckPromotions = () =>
  useMutation<Promotion, Error, PromotionCodeCheckParams>({
    mutationKey: ['promotions', 'check'],
    mutationFn: (params: PromotionCodeCheckParams) => promotions.check(params),
  });
